export default {
  pillars: {
    sectionTitle: 'Basetao Guides & Resources',
    sectionSubtitle:
      'Practical guides on spreadsheets, shipping, QC, sellers, safety and more to help you shop smarter.',
    readMore: 'Read guide',
    guide: {
      title: 'The Complete Basetao Spreadsheet Guide',
      desc: 'Build and use a Basetao spreadsheet to organize links, sellers, QC and shipping.',
    },
    review: {
      title: 'Basetao Review',
      desc: 'How the Basetao shopping agent works, its strengths and its limits.',
    },
    shipping: {
      title: 'Basetao Shipping Cost Guide',
      desc: 'Understand how shipping costs are calculated and how to save.',
    },
    warehouse: {
      title: 'Basetao Warehouse Guide',
      desc: 'How storage, consolidation and QC work at the Basetao warehouse.',
    },
    qc: {
      title: 'Basetao QC & Quality Check Guide',
      desc: 'What to check in QC photos and how to catch problems early.',
    },
    sellers: {
      title: 'Basetao Trusted Sellers Guide',
      desc: 'How to evaluate and choose reliable sellers for your haul.',
    },
    coupons: {
      title: 'Basetao Coupons & Discount Codes',
      desc: 'Where to find discounts and how to use them honestly.',
    },
    safety: {
      title: 'Is Basetao Legit & Safe?',
      desc: 'Practical steps to protect your account, payments and purchases.',
    },
    vs: {
      title: 'Basetao vs Superbuy Comparison',
      desc: 'Compare fees, features and workflow between two popular agents.',
    },
    beginner: {
      title: 'Basetao Beginner Guide',
      desc: 'A simple step-by-step guide for your first Basetao order.',
    },
  },
};